import React, { Component } from "react";

export default class ConferencesSetting extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      maxNum: 0,
      bamboohr: false,
    };
  }

  onSave = (event) => {
    event.preventDefault();
    console.log("On Save will be placed here");
  };

  toggleChangeBamboohr = () => {
    this.setState({
      bamboohr: !this.state.bamboohr,
    });
  };

  handleSelectChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  render() {
    return (
      <div>
        <div className="bg-light p-3 my-1">
          <b>Conferances</b>
        </div>
        <div className="row">
          <div className="col-1" />
          <div className="col-12 col-sm-12 col-md-10 ">
            <div className="row">
              <p className="col-2 pt-1">Type</p>
              <select
                id="select"
                name="type"
                className="form-control col-8"
                onChange={this.handleSelectChange}
              >
                <option value="IntegratedVideoConferance">
                  Integrated Video Conferance
                </option>
                <option value="BigBlueButton">BigBlueButton</option>
                <option value="GoToMeeting">GoToMeeting</option>
                <option value="GoToWebinar">GoToWebinar</option>
                <option value="GoToTraining">GoToTraining</option>
                <option value="Zoom.us">Zoom.us</option>
              </select>
              <i
                className="fa fa-info-circle col-1 pt-2"
                styles="font-size:36px"
              ></i>
            </div>
            {this.state.type === "Zoom.us" ? (
              <div className="row">
                <p className="col-2 pt-1">Max Student</p>
                <input
                  type="number"
                  name="maxNum"
                  value={this.state.maxNum}
                  className="form-control col-8"
                  onChange={this.handleSelectChange}
                  placeholder="Enter the maximun number of admitting student"
                />
                <i
                  className="fa fa-info-circle col-1 pt-2"
                  styles="font-size:36px"
                ></i>
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-1" />
        </div>
        <div className="bg-light p-3 my-1">
          <b>BAMBOOHR INTEGRATION</b>
        </div>
        <div className="row">
          <div className="col-2" />
          <div className="col-12 col-sm-12 col-md-8 ">
            <div className="row ml-3">
              <label>
                <input
                  type="checkbox"
                  checked={this.state.bamboohr}
                  onChange={this.toggleChangeBamboohr}
                  className="mr-2"
                />
                Enable bambooHR Integration
                <i
                  className="fa fa-info-circle col-1 pt-2"
                  styles="font-size:36px"
                ></i>
              </label>
            </div>
          </div>
          <div className="col-2" />
        </div>
        <div className="bg-light p-3 my-1">
          <b>CUSTOM FIELDS</b>
        </div>
        <div className="row">
          <div className="col-2" />
          <div className="col-12 col-sm-12 col-md-8 ">
            <div className="row ml-3">
              <h5>
                <i className="fa fa-book" /> Custom course field{" "}
                <span className="badge badge-pill badge-info">2</span>
                <i
                  className="fa fa-info-circle col-1 pt-2"
                  styles="font-size:36px"
                ></i>
              </h5>
            </div>
            <div className="row ml-3">
              <h5>
                <i className="fa fa-user" /> Custom User field{" "}
                <span className="badge badge-pill badge-info">1</span>
                <i
                  className="fa fa-info-circle col-1 pt-2"
                  styles="font-size:36px"
                ></i>
              </h5>
            </div>
          </div>
          <div className="col-2" />
        </div>
        <div className="p-3 m-0 border-top">
          <div className="btn btn-primary" onClick={this.onSave}>
            {" "}
            Save
          </div>{" "}
          or{" "}
          <a className="btn-link" href="#/admin/dashboard">
            Cancel
          </a>
        </div>
      </div>
    );
  }
}
